// @flow
import * as React from 'react'
import tw from 'tailwind-styled-components'
import { Close } from 'ui/Icons'

type Props = {
  onHide?: () => void,
}

function ModalCloseButton({ onHide }: Props): React.Node {
  return (
    <div className='text-base absolute right-4 top-4'>
      <button className='focus:outline-none' onClick={onHide}>
        <Close />
      </button>
    </div>
  )
}

export default ModalCloseButton
